import React from 'react';
import { Helmet } from 'react-helmet';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Ben Shirinian</title>
        <link rel="canonical" href="https://lookoutcontent.com" />
        <style>{`
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { background: #000; }
          img { display: block; width: 100%; height: 100vh; object-fit: cover; object-position: left center; }
          @media (max-width: 600px) { img { object-position: center bottom; } }
        `}</style>
      </Helmet>
      <picture>
        <source media="(max-width: 600px)" srcSet="/mobile-ben.jpeg" />
        <img src="/desktop-ben.jpeg" alt="Ben Shirinian" />
      </picture>
    </>
  );
}
